import Vue from "vue";
import VueRouter from "vue-router";

import HomePage from "@/pages/home/HomePage";
import LocalRegister from "@/pages/register/LocalRegister";
import LocalAddInfo from "@/pages/register/LocalAddInfo";
import QRCodeCome from "@/pages/qrcode/QRCodeCome";
import QRCodeLeave from "@/pages/qrcode/QRCodeLeave";
import PinCodeCome from "@/pages/pincode/PinCodeCome.vue";
import PinCodeLeave from "@/pages/pincode/PinCodeLeave.vue";
import SuperPage from "@/components/SuperPage";

import {myPath} from "@/utils/constant";
import TestPage from "@/TestPage.vue";
import LoadingPage from "@/pages/home/LoadingPage.vue";
import RegisterSelectPage from "@/pages/register/RegisterSelectPage.vue";
import EnterSelectPage from "@/pages/select/EnterSelectPage.vue";
import LeaveSelectPage from "@/pages/select/LeaveSelectPage.vue";
import IdCardRegister from "@/pages/register/IdCardRegister.vue";
import PhoneNoCome from "@/pages/phone/PhoneNoCome.vue";
import PhoneNoLeave from "@/pages/phone/PhoneNoLeave.vue";
import IdCardCome from "@/pages/idCard/IdCardCome.vue";
import IdCardLeave from "@/pages/idCard/IdCardLeave.vue";
import PrintPage from "@/pages/print/PrintPage.vue";
import SettingPage from "@/pages/home/SettingPage.vue";
import SignEnterPage from "@/pages/signEnter/SignEnterPage.vue";

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
            throw error
        }
    })
}

export default new VueRouter({
    routes: [
        {path: "/", redirect: "/loading"},
        {name: myPath.loading, path: "/loading", component: LoadingPage},
        {name: myPath.home, path: "/home", component: HomePage},
        {name: myPath.setting, path: "/setting", component: SettingPage},
        {name: myPath.signEnter, path: "/sign-enter", component: SignEnterPage},
        {
            path: "/register", redirect: "/register/select", component: SuperPage,
            children: [
                {name: myPath.registerSelect, path: "select", component: RegisterSelectPage},
                {name: myPath.localRegister, path: "local", component: LocalRegister},
                {name: myPath.idCardRegister, path: "idCard", component: IdCardRegister},
                {name: myPath.localAddInfo, path: "addInfo", component: LocalAddInfo},
            ]
        },
        {
            path: "/select", redirect: "/select/select", component: SuperPage,
            children: [
                {name: myPath.enterSelect, path: "enter", component: EnterSelectPage},
                {name: myPath.leaveSelect, path: "leave", component: LeaveSelectPage},
            ]
        },
        {
            path: "/phone", redirect: "/phone/phone", component: SuperPage,
            children: [
                {name: myPath.phoneCome, path: "enter", component: PhoneNoCome},
                {name: myPath.phoneLeave, path: "leave", component: PhoneNoLeave},
            ]
        },
        {
            path: "/idcard", redirect: "/idcard/idcard", component: SuperPage,
            children: [
                {name: myPath.idCardCome, path: "enter", component: IdCardCome},
                {name: myPath.idCardLeave, path: "leave", component: IdCardLeave},
            ]
        },
        {
            path: "/qrcode", redirect: "/qrcode/come", component: SuperPage,
            children: [
                {name: myPath.qrcodeCome, path: "come", component: QRCodeCome},
                {name: myPath.qrcodeLeave, path: "leave", component: QRCodeLeave},
            ]
        },
        {
            path: "/visitCode", redirect: "/visitCode/come", component: SuperPage,
            children: [
                {name: myPath.visitCodeCome, path: "come", component: PinCodeCome},
                {name: myPath.visitCodeLeave, path: "leave", component: PinCodeLeave},
            ]
        },
        {name: myPath.printPage, path: "/printPage", component: PrintPage},
        {name: 'test', path: "/test", component: TestPage},

    ]
})
